import React from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase/app';
import { connect } from 'react-redux';
// import * as SELECTORS from "../redux/Redux.selectors";


// Configure FirebaseUI.
const uiConfig = {
  // Popup sign-in flow rather than redirect flow.
  signInFlow: 'popup',
  // Redirect to /dashboard after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInSuccessUrl: '/dashboard',
  // We will display Google as auth provider.
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ]
};

const mapStateToProps = state => {
  return ({
    isAuthenticated: state.views.isAuthenticated,
    isAuthorized: state.views.isAuthorized,
  });
};

class SignInScreen extends React.Component {
  render() {
    const { isAuthenticated, isAuthorized, isInitialLoading } = this.props;
    const needsValidation = isAuthenticated && !isAuthorized;
    return (
      <div>
        <h1>Lake County CSD Accountability Tracking</h1>
        <p>Please sign-in:</p>
        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
        {needsValidation && !isInitialLoading &&
        (<div>
          <div>Trouble logging in? For access please contact the administrator:</div>
          <p></p>
          <img
            alt="admin at therealityway dot com"
            src="http://safemail.justlikeed.net/e/1591a9d103aa4c2476646f73cca3de79.png" // 12pt font
            //src="http://safemail.justlikeed.net/e/08b82d4c4d5a659b9eb927b1964a7068.png" // 10pt font
            border="0"
            align="absbottom"
            title="Email image created with safemail.justlikeed.net"
          />
        </div>)
        }
      </div>
    );
  }
}

export default connect(mapStateToProps)(SignInScreen);
